import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '../../../hooks/useAnalytics';

const AnalyticsTracker = () => {
  const location = useLocation();
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    // Get page name from pathname
    const pathname = location.pathname;
    let screenName = 'Unknown';
    
    // Marketing/Unauthenticated Routes
    if (pathname === '/') {
      screenName = 'Home';
    } else if (pathname === '/login') {
      screenName = 'Login';
    } else if (pathname === '/signup') {
      screenName = 'Signup';
    } else if (pathname === '/beta-landing') {
      screenName = 'Beta Landing';
    } else if (pathname === '/beta-signup') {
      screenName = 'Beta Signup';
    } else if (pathname === '/about') {
      screenName = 'About';
    } else if (pathname === '/for-creators') {
      screenName = 'For Creators';
    } else if (pathname === '/blog') {
      screenName = 'Blog';
    } else if (pathname.startsWith('/blog/')) {
      screenName = 'Blog Post';
    } else if (pathname === '/creator-signup') {
      screenName = 'Creator Signup';
    }
    
    // Main App Routes (Authenticated)
    else if (pathname === '/dashboard') {
      screenName = 'Dashboard';
    } else if (pathname === '/models') {
      screenName = 'Models';
    } else if (pathname === '/analytics') {
      screenName = 'Analytics';
    } else if (pathname === '/help') {
      screenName = 'Help Center';
    } else if (pathname.startsWith('/model/')) {
      screenName = 'Model Details';
    } else if (pathname === '/onboard') {
      screenName = 'Onboarding';
    }

    // Admin Routes
    else if (pathname === '/admin') {
      screenName = 'Admin Users';
    } else if (pathname === '/admin/labs') {
      screenName = 'Admin Labs';
    } else if (pathname === '/admin/feature-templates') {
      screenName = 'Admin Feature Templates';
    } else if (pathname === '/admin/outcomes') {
      screenName = 'Admin Outcomes';
    } else if (pathname === '/admin/tokens') {
      screenName = 'Admin Tokens';
    } else if (pathname === '/admin/model-explorer') {
      screenName = 'Admin Model Explorer';
    } else if (pathname === '/admin/debug') {
      screenName = 'Admin Debug';
    }

    // Track the page view
    trackPageView({
      screen_name: screenName,
      screen_class: `${screenName.replace(/\s+/g, '')}Page`,
      page_location: window.location.href
    });
  }, [location, trackPageView]);

  return null; // This component doesn't render anything
};

export default AnalyticsTracker; 